export default "__VITE_ASSET__C_DTN3qn__"